import revive_payload_client_4sVQNw7RlN from "/home/forge/client-solarrechner.der-solarteur.com/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/forge/client-solarrechner.der-solarteur.com/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/forge/client-solarrechner.der-solarteur.com/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/forge/client-solarrechner.der-solarteur.com/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/forge/client-solarrechner.der-solarteur.com/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_A0OWXRrUgq from "/home/forge/client-solarrechner.der-solarteur.com/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/home/forge/client-solarrechner.der-solarteur.com/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/forge/client-solarrechner.der-solarteur.com/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import sentry_client_VdOeuw25Mb from "/home/forge/client-solarrechner.der-solarteur.com/node_modules/@sentry/nuxt/build/module/runtime/plugins/sentry.client.js";
import sentry_client_config_o34nk2sJbg from "/home/forge/client-solarrechner.der-solarteur.com/.nuxt/sentry-client-config.mjs";
import i18n_yfWm7jX06p from "/home/forge/client-solarrechner.der-solarteur.com/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import chunk_reload_client_UciE0i6zes from "/home/forge/client-solarrechner.der-solarteur.com/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_AUP22rrBAc from "/home/forge/client-solarrechner.der-solarteur.com/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.js";
import api_GFfDXud5Cr from "/home/forge/client-solarrechner.der-solarteur.com/plugins/api.ts";
import super_matomo_plugin_client_r8vStMjlqe from "/home/forge/client-solarrechner.der-solarteur.com/plugins/super-matomo-plugin.client.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  sentry_client_VdOeuw25Mb,
  sentry_client_config_o34nk2sJbg,
  i18n_yfWm7jX06p,
  chunk_reload_client_UciE0i6zes,
  plugin_AUP22rrBAc,
  api_GFfDXud5Cr,
  super_matomo_plugin_client_r8vStMjlqe
]